import "./polyfills";

import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";

import Log from "utils/log";
import getStore from "utils/getStore";

import App from "./components/App"; // Leave this as a dot-slash import to make HMR work.

const store = getStore();

if (store && "getState" in store) {
  const hydratedState = store.getState();
  const { user } = hydratedState;
  Log.setUserContext(user && "email" in user ? user : { email: "Unknown" });
  window.dataLayer.push({ "userID Data Layer Var": user.id }); //Adds user id to Analytics
}

const render = () => {
  ReactDOM.render(
    <Provider store={store}>
      <App />
    </Provider>,
    document.getElementById("app")
  );
};

if (module.hot) {
  module.hot.accept("./components/App", () => {
    render();
  });
}

render();
